<template>
    <div class='swiperBgSetting'>
        <tab @getTab="getTab"></tab>
        <div id='content' v-if="status === 'content'">
            <div class='headerSerc-item'>
                <span>{{setTingObj.storeSelectConfig.title}}</span>
                <storeSelectConfig :setTingObj="setTingObj"></storeSelectConfig>
            </div>
        </div>
        <div id='style' v-if="status ==='style'">
            <div class='headerSerc-item'>
                <span>{{setTingObj.bgColor.title}}</span>
                <bgColor :defaultColor="setTingObj.bgColor.default" :color="setTingObj.bgColor.color" @updateBgColorA="updateBgColorA" @updateBgColorB="updateBgColorB"></bgColor>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.titleColor.title}}</span>
                <color :colorObj="setTingObj.titleColor"></color>
            </div>
        </div>
    </div>
</template>

<script>
import tab from '@/components/decoration/common/tab.vue';
import radio from '@/components/decoration/common/radio.vue';
import bgColor from '@/components/decoration/common/bgColor.vue';
import color from '@/components/decoration/common/color.vue';
import StoreSelectConfig from '@/components/decoration/common/storeSelectConfig.vue';

export default {
    components: {
        StoreSelectConfig,
        color,
        bgColor,
        tab,
        radio
    },
    props: {
        setTingObj: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            status: 'content'
        };
    },
    methods: {
        getTab(e) {
            this.status = e;
        },
        updateBgColorA(e){
            this.setTingObj.bgColor.color[0].item = e
        },
        updateBgColorB(e){
            this.setTingObj.bgColor.color[1].item = e
        },
    }
};
</script>

<style scoped lang='scss'>
</style>